// Imports
import MicroModal from 'micromodal';

// Project modules
import env from '@js/utils/env';
import PageScrolling from "@js/modules/PageScrolling";

class Modals {
    constructor() {
        this.initialized = false;
        this.activeTrigger = null;
        this.handleOpenClick = this.handleOpenClick.bind(this);
    }
    init() {
        if (this.initialized) {
            return;
        }

        document.addEventListener('click', this.handleOpenClick);
        this.initialized = true;
    }

    getOptions() {
        return {
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
            onShow: (modal, trigger, event) => {
                let trig = this.activeTrigger || (env.isSafari ? event?.target : trigger),
                    type = trig.getAttribute('data-modal-type'),
                    content = null;

                // Lock scroll
                PageScrolling.lock(modal);

                // Add open class to HTML element
                document.documentElement.classList.add(window.HOYT.helpers.ModalOpenClass);

                if (type === 'tour') {
                    modal.classList.add('_full', '_light');

                    let url = trig.getAttribute('data-url');

                    content = '<iframe class="h-full w-full" allow="autoplay; gyroscope; accelerometer" src="' + url + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'
                }
                else if (type === 'vimeo') {
                    let url = trig.getAttribute('data-url');

                    content = '<div class="modal-video-stage mx-auto flex h-full w-full items-center justify-center"><div class="aspect-video w-full max-w-6xl"><iframe class="h-full w-full" allow="autoplay; fullscreen; picture-in-picture" src="' + url + '" frameborder="0" allowfullscreen></iframe></div></div>';
                }

                // Modal content
                modal.querySelector('.modal-content').innerHTML = content;
            },
            onClose: (modal) => {
                this.activeTrigger = null;

                // Remove full class from modal
                modal.classList.remove('_full', '_light');

                // Clear modal content
                modal.querySelector('.modal-content').innerHTML = '';

                // Unlock scroll
                PageScrolling.unlock(modal);

                // Remove open class to HTML element
                document.documentElement.classList.remove(window.HOYT.helpers.ModalOpenClass);
            },
            openTrigger: 'data-modal-open',
            closeTrigger: 'data-modal-close',
        };
    }

    handleOpenClick(event) {
        const trigger = event.target.closest('[data-modal-open]');

        if (!trigger) {
            return;
        }

        const modalId = trigger.getAttribute('data-modal-open');

        if (!modalId) {
            return;
        }

        event.preventDefault();
        this.activeTrigger = trigger;
        MicroModal.show(modalId, this.getOptions());
    }
}

export default new Modals();
